import styled from 'styled-components';
import { white, contiOrange } from '../../style/colors';

export const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 32px;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  flex-wrap: wrap;
  gap: 16px;
`;

export const Title = styled.h1`
  font-size: 32px;
  font-weight: 700;
  color: #111827;
  margin: 0;
  
  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

export const MetricsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-bottom: 32px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const ChartsGrid = styled.div`
  display: grid;
  grid-template-columns: ${({ $fullWidth }) => $fullWidth ? '1fr' : 'repeat(2, 1fr)'};
  gap: 24px;
  margin-bottom: 32px;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

export const Section = styled.section`
  margin-bottom: 32px;
`;

export const SectionTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 20px 0;
  padding-bottom: 12px;
  border-bottom: 2px solid ${contiOrange};
  display: inline-block;
`;

export const DepartmentGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
`;

export const DepartmentCard = styled.div`
  background: ${white};
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  gap: 12px;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    border-color: ${contiOrange};
  }
`;

export const DepartmentName = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;

  i {
    font-size: 20px;
    color: ${contiOrange};
  }
`;

export const DepartmentRevenue = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: #111827;
`;

export const EmptyState = styled.div`
  background: ${white};
  border-radius: 8px;
  padding: 60px 20px;
  text-align: center;
  color: #9ca3af;
  font-size: 14px;
  border: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;

  i {
    font-size: 48px;
    color: #d1d5db;

    &.mdi-spin {
      color: ${contiOrange};
    }
  }
`;


